import React, { useState, useEffect, useRef } from 'react';
import styled from "styled-components";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const MultiSelectDropdownCheckbox = ({ placeholder, name, options, selectedStates, setSelectedStates, onFilterChange }) => {
  const [displayStatesList, setDisplayStatesList] = useState(false);
  const [stateAllChecked, setStateAllChecked] = useState(false); // Set default to false
  const [stateSearch, setStateSearch] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (name === 'status' && (options?.length === selectedStates?.length)) setStateAllChecked(true)
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDisplayStatesList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredOptions = options?.filter(option =>
    option.label.toLowerCase().includes(stateSearch.toLowerCase()) ||
    option?.city && option.city.toLowerCase().includes(stateSearch.toLowerCase()) ||
    option?.state && option.state.toLowerCase().includes(stateSearch.toLowerCase())
  );

  const onCheckStateBox = (value, checked) => {
    if (value === 'ALL') {
      setStateAllChecked(checked);
      if (checked) {
        setSelectedStates(options.map(option => option.value));
      } else {
        setSelectedStates([]);
      }
    } else {
      setSelectedStates(prevSelectedStates => {
        let newSelectedStates;
        if (!Array.isArray(prevSelectedStates)) {
          // If prevSelectedStates is not an array, initialize it as an empty array
          newSelectedStates = [];
        } else {
          newSelectedStates = [...prevSelectedStates];
        }
        if (checked) {
          // Add the value to selectedStates
          newSelectedStates.push(value);
        } else {
          // Remove the value from selectedStates
          const index = newSelectedStates.indexOf(value);
          if (index !== -1) {
            newSelectedStates.splice(index, 1);
          }
        }
        // If the length of newSelectedStates is equal to the length of options, set stateAllChecked to true, otherwise false
        setStateAllChecked(newSelectedStates.length === options.length);
        return newSelectedStates;
      });
    }
    // Trigger the API call in the parent component
    // onFilterChange();
  };


  return (
    <LocationPrefWrapper ref={dropdownRef}>
      <DropdownToggle onClick={() => setDisplayStatesList(!displayStatesList)}>
        {placeholder ? placeholder : "Select"}
        <ExpandMoreIcon style={{ color: "inherit" }} />
      </DropdownToggle>
      {displayStatesList && (
        <StatesListDiv className="statesListDiv">
          <div className="searchContainer">
            <input
              type="text"
              placeholder="Search..."
              value={stateSearch}
              onChange={(e) => setStateSearch(e.target.value)}
              id={`DropDown_${name}`}
            />
          </div>
          {filteredOptions.length > 0 ? (
            <div className="statesListInnerDiv">
              <label className='checkbox-container' style={{ margin: '10px' }}>
                <input
                  id={`ALL_${name}`}
                  name={`ALL_${name}`}
                  type='checkbox'
                  checked={stateAllChecked}
                  disabled={false}
                  onClick={(event) => {
                    onCheckStateBox('ALL', event.target.checked)
                  }}
                />
                <span className='checkMark'></span>
                All
              </label>
              {filteredOptions.map(item => (
                <label className='checkbox-container' style={{ margin: '10px' }}>
                  <input
                    id={`${name}_${item.label}`}
                    name={`${name}_${item.label}`}
                    type='checkbox'
                    checked={selectedStates && selectedStates.includes(item.value)}
                    disabled={false}
                    onChange={(event) => onCheckStateBox(item.value, event.target.checked)}
                  />
                  <span className='checkMark'></span>
                  {name === "vendorIds" ?
                    item.label :
                    `${item.label}${item.city ? `, ${item.city}` : ''}${item.state ? `, ${item.state}` : ''}`
                  }
                </label>

              ))}
            </div>
          ) : (
            <div>No data available</div>
          )}
        </StatesListDiv>
      )}
    </LocationPrefWrapper>
  );

};

export default MultiSelectDropdownCheckbox;

const LocationPrefWrapper = styled.div`
  margin: 10px 0 10px 0;
  position: relative;
  button{
    background: #fff;
    width: 100%;
    height: 37px;
    min-width: 190px;
  }
`;

const DropdownToggle = styled.button`
  height: 37px;
  border-radius: 5px;
  border: solid 1px #e0e0e0;
  width: 200px;
  padding: 7px;
  cursor: pointer;
  font-size: 13px;
  .MuiSvgIcon-root{
    float: right;
    font-size: 1.3rem;
  }
`;

const StatesListDiv = styled.div`
  position: absolute;
  top: 37px; /* Adjust as per your design */
  left: 0;
  background-color: white;
  z-index: 1000; /* Set a high value to ensure it's above other content */
  border: 1px solid #87cdf1;
  border-radius: 5px;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: left;

  .searchContainer {
    margin-bottom: 10px;
  }

  .searchContainer input {
    width: calc(100% - 10px);
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
  }
  .searchContainer input[type=text]:focus {
    border: 1px solid #e0e0e0;
  }

  /* The container */
  .checkbox-container {
    display: block;
    position: relative;
    padding-left: 24px;
    margin-bottom: 0;
    cursor: pointer;
    font-size: 14px !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: "latoregular" !important;
    letter-spacing: 0.23px !important;
    color: inherit;
  }
  
  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  /* Create a custom checkbox */
  .checkMark {
    position: absolute;
    top: 0;
    left: 0;
    background-color: transparent;
    border-radius: 2px;
    border: solid 2px #61ae24;
    height: 18px;
    width: 18px;
  }
  
  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkMark {
    background-color: transparent;
  }
  
  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkMark {
        background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
  }
  /* Create the checkMark/indicator (hidden when not checked) */
.checkMark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkMark when checked */
.checkbox-container input:checked ~ .checkMark:after {
  display: block;
}

/* Style the checkMark/indicator */
.checkbox-container .checkMark:after {
  left: 4px;
  top: 0px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
`;  
